/**
 * Usage
 * -------------------------------------
 *
 * (1) In child theme functions.php, initialise the AJAX handler in the
 * after_setup_theme action with the line:
 *
 * 	Ajax\AddToCartAjaxHandler::init();
 *
 * 
 * (2) In template, create something like the following:
 *
 * <div data-atc="42">
 *     <select data-atc-variation>
 *         <option value="43">My variation</option>
 *         ...
 *     </select>
 *     <input type="number" data-atc-qty value="1" />
 *     <button data-atc-submit>Add to cart</button>
 * </div>
 *
 * (where 42 is the product id and 43 is a variation id).
 *
 * The data-atc-variation and data-atc-qty inputs are optional.
 *
 * 
 * (3) In JS, listen for jQuery "submit", "success", "error" events fired on the 
 * [data-atc] container element.
 *
 * On error, if there is a user error message, it can be obtained from eventData.errorMsg
 * (where eventData is the second argument passed to the [data-atc] error handler).
 *
 * On error, HTTP response status code should be available from eventData.status.
 * 
 * On success, the full response from the server is provided to the 'success' handler
 * as an object (this will include a 'totals' object).
 * 
 * 
 */

declare const jQuery: any;
const $ = jQuery;

import { get } from "lodash";
import { ajaxCall } from "./utils/misc";

export function initAddToCart(): void
{
	const $wraps = $(`[data-atc]`);
	if ($wraps.length === 0)
	{
		return;
	}
	const sendData = async function (ajaxData, $wrap, $submit) {
		$submit.attr("disabled", "");
		$wrap.addClass("busy").trigger("submit", { ajaxData });
		try
		{
			const response = await ajaxCall("iw_add_to_cart", ajaxData);
			if (!response || !response.ok)
			{
				throw { response };
			}
			$wrap.removeClass("busy").trigger("success", response);
		}
		catch (error)
		{
			console.error("Failed to add to cart:", error);
			error = error || {};
			const errorMsg: string = get(error, "response.error");
			const eventData = {
				errorMsg,
				error,
				ajaxData,
				status: error.status
			};
			$wrap.removeClass("busy").trigger("error", eventData);
		}
		$submit.removeAttr("disabled");
	};
	$wraps.each(function () {
		const $wrap = $(this);
		const $submit = $wrap.find(`[data-atc-submit]`);
		const $variation = $wrap.find(`[data-atc-variation]`);
		const $qty = $wrap.find(`[data-atc-qty]`);
		$submit.click(function (): false {
			const productId: number = parseInt($wrap.attr("data-atc"), 10);
			if (!productId)
			{
				console.error(`productId not set in data-atc`);
				return false;
			}
			const variationId: number = parseInt($variation.val(), 10) || null;
			const qty: number = parseInt($qty.val(), 10) || 1;
			const ajaxData = { productId, variationId, qty };
			sendData(ajaxData, $wrap, $submit);
			return false;
		});
	});
}

